import { SimulatorType } from "@/types/api/SimulatorType"

/**
 * `MODEL_TYPE_TEXT` — a legacy backend value some rows/agents still carry
 * for the same thing `SimulatorType.TEXT` ("MODEL_TYPE_CHAT") now names.
 * Not a member of `SimulatorType` itself; see the same normalization in
 * `useEvaluationData.ts`'s `toSimulatorType`.
 */
const LEGACY_TEXT_MODEL_TYPE = "MODEL_TYPE_TEXT"

/**
 * Simulator types that never produce audio, enumerated directly against
 * `SimulatorType` rather than derived from the `SIMULATOR_TYPES` picker
 * list — that list is UI-curated for the simulator-creation form (its own
 * "Text to Text" group omits `CHAT_WEBSOCKET`, which carries no audio
 * either) and can drift from the actual no-audio set without either list
 * being obviously wrong on its own.
 *
 * `WEBSOCKET` (plain, non-chat) is deliberately left out: the picker groups
 * it under "Voice to Voice" as real-time bidirectional audio, not a text
 * protocol.
 */
const NO_AUDIO_TYPES = new Set<string>([
  SimulatorType.TEXT,
  SimulatorType.CHAT_A2A,
  SimulatorType.CHAT_WEBSOCKET,
  SimulatorType.SMS,
  LEGACY_TEXT_MODEL_TYPE,
])

/** Whether a simulator type produces no audio. */
export function isTextBasedSimulator(
  modelType: string | null | undefined,
): boolean {
  return modelType != null && NO_AUDIO_TYPES.has(modelType)
}
